import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../../store';
import { VIEWS_MAP } from '../../../router/constants';

export const AccountantAi = () => {
  const { customerId } = useStore((state) => state.user);
  const routerHistory = useStore((state) => state.routerHistory);
  const navigate = useNavigate();

  function getIframeUrl() {
    if (process.env.REACT_APP_HOST_ENV) {
      return 'https://accountant-integ.lili.co';
    }
    if (process.env.REACT_APP_NODE_ENV === 'production') {
      return 'https://accountant.lili.co';
    }
    return 'https://accountant-integ.lili.co';
  }

  useEffect(() => {
    window.addEventListener('message', (e) => {
      const {
        origin,
        data: { shouldCloseIframe },
      } = e;
      if (origin.includes('.lili.co') && shouldCloseIframe) {
        navigate(`/${VIEWS_MAP.DASHBOARD}`, { replace: true });
        if (!routerHistory[routerHistory.length - 2]) {
          setTimeout(() => {
            navigate(`/${VIEWS_MAP.DASHBOARD}`, { replace: true });
          }, 500);
        }
      }
    });
    return () => {
      window.removeEventListener('message', () => {});
    };
  }, []);
  return (
    <div className='absolute z-[99999] inset-0 bg-bw00 flex items-center justify-center'>
      <iframe className='w-full h-full' src={`${getIframeUrl()}?customerId=${customerId}`} title='Accountant AI' />
    </div>
  );
};
